// Adaptive threshold: score >= this on Module 1 → hard Module 2
const ADAPTIVE_THRESHOLD = 0.70;

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

// Equal spread across difficulties 1, 2, 3.
// Remainder goes to difficulty 3 (harder bias matches real SAT Module 1).
export function selectModule1Questions(pool, count) {
  const base = Math.floor(count / 3);
  const remainder = count % 3;

  const d1 = shuffle(pool.filter((q) => q.difficulty === 1));
  const d2 = shuffle(pool.filter((q) => q.difficulty === 2));
  const d3 = shuffle(pool.filter((q) => q.difficulty === 3));

  const selected = [
    ...d1.slice(0, base),
    ...d2.slice(0, base),
    ...d3.slice(0, base + remainder),
  ];

  // Fallback: fill from remaining pool if any difficulty tier is short
  if (selected.length < count) {
    const usedIds = new Set(selected.map((q) => String(q._id)));
    const extra = shuffle(pool.filter((q) => !usedIds.has(String(q._id))));
    selected.push(...extra.slice(0, count - selected.length));
  }

  return shuffle(selected).slice(0, count);
}

// Determine Module 2 tier based on Module 1 performance.
// Kept isolated so the threshold and logic can be iterated independently.
export function getModule2Tier(module1Questions, answers) {
  if (!module1Questions.length) return 'easy';
  const correct = module1Questions.filter((q) => {
    const selected = answers[String(q._id)];
    return q.options?.some((o) => o.id === selected && o.correct);
  }).length;
  return correct / module1Questions.length >= ADAPTIVE_THRESHOLD ? 'hard' : 'easy';
}

// Select Module 2 questions based on tier, excluding already-used Module 1 questions.
// Falls back to the remaining pool if the tier-filtered set is too small.
export function selectModule2Questions(pool, count, tier, excludeIds) {
  const excluded = new Set(excludeIds.map(String));
  const available = pool.filter((q) => !excluded.has(String(q._id)));

  const tierPool = shuffle(
    tier === 'hard'
      ? available.filter((q) => q.difficulty === 3)
      : available.filter((q) => q.difficulty <= 2),
  );

  if (tierPool.length >= count) return tierPool.slice(0, count);

  const usedIds = new Set(tierPool.map((q) => String(q._id)));
  const fallback = shuffle(available.filter((q) => !usedIds.has(String(q._id))));
  return [...tierPool, ...fallback].slice(0, count);
}

// Approximate scaled SAT score: 200–800, rounded to nearest 10.
export function toScaledScore(correct, total) {
  if (!total) return 200;
  return Math.round((200 + (correct / total) * 600) / 10) * 10;
}
